/** Colore di un tratto in funzione dell'ombra: arancio (sole) → indaco (ombra). */
export function shadeColor(shade: number): string {
  const s = Math.max(0, Math.min(1, shade));
  const from = [255, 159, 10]; // #FF9F0A
  const to = [94, 92, 230]; // #5E5CE6
  const c = from.map((f, i) => Math.round(f + (to[i] - f) * s));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
}
